/* まとめ買い施策の告知モーダル（sections/sh-campaign-modal.liquid）
   - 1セッションにつき1回だけ表示する（sessionStorage: sh-campaign-modal-shown）
   - 「広告からの流入時のみ」が ON の場合は、ランディング時の URL に広告パラメータがあったセッションだけ表示する
     （判定結果は sessionStorage: sh-campaign-ad-visit に保存し、別の PDP へ遷移しても保持する）
   - 表示する場合は window.shCampaignModalActive = true を立て、sh-newsletter-modal.js 側で表示をスキップさせる
   - 開いている間は body.sh-campaign-modal-open を付け、Shopify Forms（アプリ埋め込み）のポップアップを隠す */
(function () {
  var SHOWN_KEY = 'sh-campaign-modal-shown';
  var AD_KEY = 'sh-campaign-ad-visit';
  var AD_PARAMS = ['utm_source', 'utm_medium', 'fbclid', 'gclid'];
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function getSession(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function setSession(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      // sessionStorage が使えない環境では毎回判定する
    }
  }

  function recordAdVisit() {
    var params = new URLSearchParams(window.location.search);
    var fromAd = AD_PARAMS.some(function (name) {
      return params.has(name);
    });
    if (fromAd) setSession(AD_KEY, 'true');
  }

  function ShCampaignModal(root) {
    this.root = root;
    this.dialog = root.querySelector('[role="dialog"]');
    this.closeButton = root.querySelector('.sh-campaign-modal__close');
    this.adsOnly = root.dataset.adsOnly === 'true';
    this.delay = parseInt(root.dataset.delay || '1500', 10);
    this.previousFocus = null;
    this.isOpen = false;
    this.onKeydown = this.handleKeydown.bind(this);

    var self = this;
    root.querySelectorAll('[data-sh-campaign-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        self.close();
      });
    });
  }

  ShCampaignModal.prototype.shouldShow = function () {
    if (getSession(SHOWN_KEY) === 'true') return false;
    if (this.adsOnly && getSession(AD_KEY) !== 'true') return false;
    return true;
  };

  ShCampaignModal.prototype.schedule = function () {
    if (!this.shouldShow()) return;

    window.shCampaignModalActive = true;

    // 画像は lazy で出力している（表示済みのセッションでは読み込まない）。表示が決まった時点で読み込みを始める
    this.root.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });

    var self = this;
    window.setTimeout(function () {
      // 別タブで開かれて裏にある間は出さず、タブが表に来てから少し待って表示する
      if (document.hidden) {
        document.addEventListener('visibilitychange', function onVisible() {
          if (document.hidden) return;
          document.removeEventListener('visibilitychange', onVisible);
          window.setTimeout(function () {
            self.tryOpen();
          }, 600);
        });
        return;
      }
      self.tryOpen();
    }, this.delay);
  };

  ShCampaignModal.prototype.tryOpen = function () {
    // 遅延中に別タブ等で表示済みになっていたら出さない
    if (getSession(SHOWN_KEY) === 'true') return;
    // 他のモーダル（画像拡大・サイズガイド・カート追加通知など）が開いている間は出さない
    if (document.body.classList.contains('overflow-hidden')) return;
    if (document.querySelector('.cart-notification.active')) return;
    this.open();
    setSession(SHOWN_KEY, 'true');
  };

  ShCampaignModal.prototype.open = function () {
    if (this.isOpen) return;
    this.isOpen = true;
    this.previousFocus = document.activeElement;

    this.root.hidden = false;
    // hidden 解除直後にレイアウトを確定させてから is-open を付け、transition を効かせる
    // （requestAnimationFrame は裏タブで止まり、透明のまま操作をふさぐため使わない）
    void this.root.offsetWidth;
    this.root.classList.add('is-open');

    // Dawn と同じクラスでスクロールを止める（aw-common.css の Hextom バー退避ルールもこのクラスで効く）
    document.body.classList.add('overflow-hidden');
    // 開いている間は Shopify Forms のメルマガポップアップを隠す（sh-campaign-modal.css）。閉じると元どおり出る
    document.body.classList.add('sh-campaign-modal-open');
    document.addEventListener('keydown', this.onKeydown);

    if (typeof window.trapFocus === 'function') {
      window.trapFocus(this.dialog, this.closeButton);
    } else if (this.closeButton) {
      this.closeButton.focus();
    }
  };

  ShCampaignModal.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;

    this.root.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('sh-campaign-modal-open');
    document.removeEventListener('keydown', this.onKeydown);

    var root = this.root;
    window.setTimeout(function () {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 300);

    var restoreTarget =
      this.previousFocus && typeof this.previousFocus.focus === 'function' && this.previousFocus !== document.body
        ? this.previousFocus
        : null;

    if (typeof window.removeTrapFocus === 'function') {
      window.removeTrapFocus(restoreTarget);
    } else if (restoreTarget) {
      restoreTarget.focus();
    }
  };

  ShCampaignModal.prototype.handleKeydown = function (event) {
    if (event.key === 'Escape' || event.code === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }

    // trapFocus（global.js）が無い場合の簡易フォーカストラップ
    if (event.key !== 'Tab' || typeof window.trapFocus === 'function') return;
    var focusable = Array.prototype.slice.call(this.dialog.querySelectorAll(FOCUSABLE));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  function init() {
    var root = document.getElementById('ShCampaignModal');
    if (!root || root.dataset.shInitialized === 'true') return;
    root.dataset.shInitialized = 'true';

    var modal = new ShCampaignModal(root);

    // テーマエディタではセクション選択時にプレビュー表示する（表示回数の記録はしない）
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (event) {
        if (root.closest('.shopify-section') && event.target === root.closest('.shopify-section')) modal.open();
      });
      document.addEventListener('shopify:section:deselect', function (event) {
        if (root.closest('.shopify-section') && event.target === root.closest('.shopify-section')) modal.close();
      });
      return;
    }

    modal.schedule();
  }

  recordAdVisit();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
